import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Once Buyer has nodded her or his approval, they own the stuff they paid for in the exact way they agreed with Seller at the time they paid.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      